module.exports = __webpack_public_path__ + "static/img/hh1.1263a81a.png";